module.exports = __webpack_public_path__ + "static/media/chat-close.8308eeef.svg";